module.exports = __webpack_public_path__ + "media/assets/images/smart_working/7-2-1f989960a7e5e837597aa370703cfe4f.png";